/** True when a YYYY-MM-DD date lies in the given year; a missing date is in no year. */
export const isInYear = (date: string | null | undefined, year: number): boolean =>
    typeof date === "string" && date.startsWith(`${year}-`);
